import { minAmount, validateEmail } from "@web/components/Forms"
import TomboForm from "@web/components/Tombo/Form/Form"
import TomboHomepageLayout from "@web/components/Tombo/Layout/Layout"

const HostTombo = () => {
  return (
    <TomboHomepageLayout>
      <TomboForm
        fields={[
          { name: "email", label: "Email", component: "TextField", rules: { required: true, validate: validateEmail } },
          {
            name: "send_to",
            label: "Send to",
            rules: { validate: minAmount(1) },
            component: "Select",
            multiple: false,
            options: [
              { label: "Support", value: "Support" },
              { label: "Sales", value: "Sales" },
              { label: "Engineering", value: "Engineering" },
              { label: "Managers", value: "Managers" },
            ],
          },
          {
            name: "message",
            label: "Your Message",
            component: "TextField",
            multiline: true,
            rules: { required: true },
          },
        ]}
        title="Host Tombo"
        onSubmit={() => {
          alert("OK")
        }}
      />
    </TomboHomepageLayout>
  )
}
export default HostTombo
